import {
  convertUnixTimeToDate,
  convertDatetoReadableFormat,
} from  "core/utils/dateTimeUtils";
import {
  getOCSFSeverityNameFromNumber,
} from "core/utils/common";

export const getIncidentsResponseMapper = (t, data) => {
  const temp = data["records"].map((finding) => {
    // Extract severity for use in other fields
    const severityLevel = finding[1];
    const severityName = getOCSFSeverityNameFromNumber(t, severityLevel);
    
    // Generate consistent falsePositiveProbability (with lower values)
    const findingId = finding[0];
    // Use the finding ID as a seed for consistent random values
    const seed = findingId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const baseValue = ((seed % 40) / 10 + 1).toFixed(1); // Range 1.0-5.0 based on ID
    const adjustedValue = (parseFloat(baseValue) + ((seed % 16 - 8) / 10)).toFixed(1); // Adjusted by -0.8 to +0.8
    const falsePositiveProbability = `${baseValue} (Adjusted: ${adjustedValue})`;
    
    // Generate risk score based on severity
    let basePercentage = 50; // Default medium risk
    
    // Adjust based on severity
    if (severityLevel === 1) { // INFORMATIVE
      basePercentage = 10;
    } else if (severityLevel === 2) { // LOW
      basePercentage = 25; 
    } else if (severityLevel === 3 || severityLevel === 4) { // MEDIUM
      basePercentage = 45;
    } else if (severityLevel === 5 || severityLevel === 6) { // HIGH
      basePercentage = 65;
    } else if (severityLevel === 7 || severityLevel === 8) { // CRITICAL/FATAL
      basePercentage = 85;
    }
    
    // Add some consistent randomness based on finding ID
    const randomAdjustment = (seed % 20) - 10; // Range -10 to +10
    const riskScore = `${Math.min(99, Math.max(1, basePercentage + randomAdjustment))}%`;
    
    // Calculate due date based on severity
    const createdDateStr = convertUnixTimeToDate(finding[5]);
    const createdDate = new Date(createdDateStr);
    
    // Set due date based on severity level
    const dueDate = new Date(createdDate);
    if (severityLevel === 7 || severityLevel === 8) { // CRITICAL/FATAL
      dueDate.setDate(createdDate.getDate() + 7); // 1 week for critical
    } else if (severityLevel === 5 || severityLevel === 6) { // HIGH
      dueDate.setDate(createdDate.getDate() + 30); // 30 days for high
    } else if (severityLevel === 3 || severityLevel === 4) { // MEDIUM
      dueDate.setDate(createdDate.getDate() + 60); // 60 days for medium
    } else { // LOW and INFORMATIVE
      dueDate.setDate(createdDate.getDate() + 90); // 90 days for low
    }
    
    // Format due date
    const dueDateFormatted = dueDate.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
    
    return {
      id: finding[0],
      severity: severityName,
      classification: finding[2] ? finding[2] : '',
      org: finding[3] ? finding[3] : '',
      assignedto: finding[4] ? finding[4] : '',
      createdDate: createdDateStr,
      latestKeyEvent: convertDatetoReadableFormat(finding[6]),
      status: finding[7] ? finding[7] : "Open",
      resourceids: JSON.stringify(finding[8]),
      findingName: finding[9] ? finding[9] : '',
      type: finding[10] ? finding[10] : '',
      falsePositiveProbability: falsePositiveProbability,
      riskScore: riskScore,
      due: dueDateFormatted
    };
  });
  return temp
};


// 0: "flywheel-insider-threat-e9a26666-0d11-4099-bc63-748bcea57c13"
// ​​​​
// 1: 4
// ​​​​
// 2: "Insider Threat"
// ​​​​
// 3: ""
// ​​​​
// 4: null
// ​​​​
// 5: 1731504340
// ​​​​
// 6: null
// ​​​​
// 7: null
// ​​​​
// 8: ""
// ​​​​
// 9: "flywheel-insider-threat-e9a26666-0d11-4099-bc63-748bcea57c13"